import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';

@Component({
  selector: 'app-padlock',
  templateUrl: './padlock.component.html',
  styleUrls: ['./padlock.component.scss'],

})
export class PadlockComponent {
  constructor(   public auth: RxAuthService,) { }
  public url: string = environment.wp.sign_up_url

}
